import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import { SUPPORT_HOME } from "@/modules/Support/routesInterface";
const menu = {
  code: MODULE.SUPPORT.CODE,
  name: "support",
  label: "role.support",
  link: SUPPORT_HOME,
  children: [],
  createChildren: [],
};

function getMenu() {
  return menu;
}

export default { getMenu };